const spacing = {
  tiny: 5,
  smaller: 10,
  small: 20,
  medium: 30,
  large: 40,
  larger: 60,
  huge: 80
}

export default spacing
